export const SDK_VERSION = '8.8.0';
